const initExternalRedirectModal = () => {
  const handleExternalLinkClick = (e) => {
    e.preventDefault();
    if ( window.go_header ) {
      window.go_header.mainMenuActive = false;
    }
    document.querySelector('html').classList.remove('freeze');

    const modalEl = document.getElementById('externalRedirectModal');
    const continueBtn = document.getElementById('externalRedirectContinue');
    if ( continueBtn ) {
      continueBtn.setAttribute('href', e.currentTarget.getAttribute('href'));
    }
    if ( modalEl ) {
      modalEl.classList.add('show');
      modalEl.style.display = 'block';
    }
  };

  const hideModal = () => {
    const modalEl = document.getElementById('externalRedirectModal');
    if ( modalEl ) {
      modalEl.classList.remove('show');
      modalEl.style.display = 'none';
    }
  };

  const modalEl = document.getElementById('externalRedirectModal');
  if ( modalEl ) {
    modalEl.querySelectorAll('[data-dismiss="modal"]').forEach( (el) => {
      el.addEventListener('click', hideModal);
    });
  }

  const links = document.querySelectorAll(
    'a[href*="myaccount.glashuette-original.com"], a[href*="glashuette-original.com/zh/目录/"], a[href*="glashuette-original.com/zh/联系/"], a[href*="glashuette-original.com/zh/%e7%9b%ae%e5%bd%95/"], a[href*="glashuette-original.com/zh/%e8%81%94%e7%b3%bb/"]'
  );
  links.forEach( (link) => link.addEventListener('click', handleExternalLinkClick) );
}

const initModals = function initModals()
{
  const modals = document.querySelectorAll('.modals__link');

  if( modals.length > 0 ) {
    modals.forEach( (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = item.attributes.href.value.replace('#', '');
        const modal = document.getElementById(modalId);
        const activeModal = document.querySelector('.modal-item.active');
        if ( activeModal ) {
          activeModal.classList.remove('active');
        }
        if ( modal ) {
          modal.classList.add('active');
        }
      });
    });
  }

  initExternalRedirectModal();
}
export { initModals };